var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Head',{attrs:{"title":"Reports"}}),_vm._v(" "),_c('h1',{staticClass:"mb-8 text-3xl font-bold"},[_vm._v("Reports")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }